import { AdminFilterChips } from "@/components/admin";

interface QuickFiltersProps {
  activeFilter: string;
  onFilterChange: (key: string) => void;
}

const filterChips = [
  { key: "all", label: "전체" },
  { key: "SENIOR", label: "Senior" },
  { key: "GUARDIAN", label: "Keeper" },
  { key: "ACTIVE", label: "활성" },
  { key: "INACTIVE", label: "비활성" },
  { key: "DELETED", label: "삭제" },
];

const QuickFilters = ({ activeFilter, onFilterChange }: QuickFiltersProps) => {
  return <AdminFilterChips chips={filterChips} activeKey={activeFilter} onChange={onFilterChange} />;
};

export default QuickFilters;
